export default "__VITE_ASSET__DKXWRaBj__"